import React from "react";

const ClientContacts = ({ client }) => {
  return (
    <>
      <h2 className="text-[#111418] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">
        Contacts
      </h2>
      <div className="p-4 grid grid-cols-[20%_1fr] gap-x-6">
        <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
          <p className="text-[#60758a] text-sm font-normal leading-normal">
            Contact Person
          </p>
          <p className="text-[#111418] text-sm font-normal leading-normal">
            {client.contactPerson}
          </p>
        </div>
        <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
          <p className="text-[#60758a] text-sm font-normal leading-normal">
            Email
          </p>
          <p className="text-[#111418] text-sm font-normal leading-normal">
            {client.email}
          </p>
        </div>
        <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
          <p className="text-[#60758a] text-sm font-normal leading-normal">
            Phone Number
          </p>
          <p className="text-[#111418] text-sm font-normal leading-normal">
            {client.phoneNumber}
          </p>
        </div>
        <div className="col-span-2 grid grid-cols-subgrid border-t border-t-[#dbe0e6] py-5">
          <p className="text-[#60758a] text-sm font-normal leading-normal">
            Address
          </p>
          <p className="text-[#111418] text-sm font-normal leading-normal whitespace-pre-line">
            {client.address}
          </p>
        </div>
      </div>
    </>
  );
};

export default ClientContacts;
